<template>
  <QPaginatedSearchDropdown :value="value" :list-getter="modifedGetArticleListFromFilter" :filter="filter"
    :min-search-char-limit="0" :externaledit="externaledit" :clearable="clearable" :multiple="multiple"
    :disableAttach="disableAttach" :returnobject="returnobject" :disabled="disabled" :loading="loading"
    valuekey="ArticleNumber" textkey="ArticleDescription"
    :label="label ? label : $t('servicesystem.common_objects.article.article')"
    :placeholder="placeholder ? placeholder : $t('servicesystem.common_objects.article.search_field_label')"
    @input="e => $emit('input', e)" @FocusState="e => $emit('FocusState', e)">

    <template v-if="!hideIcon" v-slot:prepend-outer>
      <v-icon size="20">$article</v-icon>
    </template>

    <template v-if="!multiple" v-slot:selection="{ item, on, attrs }">
      <v-list-item-content class="py-0" :on="on" :attrs="attrs" style="pointer-events: none;">
        <v-list-item-title style="color: var(--v-primary-base); font-size: 12px !important;">
          {{ item.ArticleNumber }}
        </v-list-item-title>
        <v-list-item-subtitle style="font-size: 12px !important;">
          {{ item.ArticleDescription }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>

    <template v-slot:item-content="{ item, highlight }">
      <v-list-item-title style="color: var(--v-primary-base); font-size: 12px !important;"
        v-html="highlight(item.ArticleNumber)">
      </v-list-item-title>
      <v-list-item-subtitle style="font-size: 12px !important;" v-html="highlight(item.ArticleDescription)">
      </v-list-item-subtitle>
    </template>

    <template v-slot:append-outer>
      <slot name="append-outer" />
    </template>

  </QPaginatedSearchDropdown>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QPaginatedSearchDropdown from "@/components/Inputs/QPaginatedSearchDropdown.vue";
import rules from "@/helpers/Mixins/QInputRuleMixin.js";

export default {
  name: "ArticleSelect2",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    placeholder: String,
    value: [Object, String, Number, Array],
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    filter: Object,
    returnobject: Boolean,
    multiple: Boolean,
    autofocus: Boolean,
    hideIcon: Boolean,
    disableAttach: Boolean,
  },
  components: {
    QPaginatedSearchDropdown,
  },
  mixins: [clientAPI, rules],

  data() {
    return {

    };
  },

  methods: {
    //The filter here is modifed to use the article numbers to prepend items instead of id's.
    async modifedGetArticleListFromFilter(filter) {
      var modifiedFilter = {
        ...filter,
        PrependArticleNumberList: filter.PrependItemIdList ? [...filter.PrependItemIdList] : [],
        PrependItemIdList: undefined,
      }
      //console.log('filter', filter, 'modifiedFilter', modifiedFilter)
      return await clientAPI.methods.getArticleListFromFilter(modifiedFilter);
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang="scss"></style>